import { UnrealisedCashFXGainOrLossType } from 'further-types/lp/unrealised-cash-fx-gain-or-loss';
import { UnrealisedFXGainOrLossSubType } from 'further-types/lp/unrealised-fx-gain-or-loss';

const lossTypes = new Set<
  UnrealisedFXGainOrLossSubType | UnrealisedCashFXGainOrLossType
>([
  UnrealisedFXGainOrLossSubType.FXLossPayable,
  UnrealisedFXGainOrLossSubType.FXLossReceivable,
  UnrealisedCashFXGainOrLossType.UnrealisedCashFXLoss,
  UnrealisedCashFXGainOrLossType.UnrealisedCashFXUnwindLoss,
]);

export default function getUnrealisedFxDisplayAmount(
  gainOrLossType:
    | UnrealisedFXGainOrLossSubType
    | UnrealisedCashFXGainOrLossType,
  amountLcy: number,
) {
  return lossTypes.has(gainOrLossType) ? -amountLcy : amountLcy;
}
